import { cva } from 'class-variance-authority';

export const cvaTabs = cva(['TabsStyles-cvaTabs', 'grid grid-cols-3 gap-0.8']);
